var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2124 6.19717C24.2124 8.45331 22.3834 10.2823 20.1273 10.2823C17.8712 10.2823 16.0422 8.45331 16.0422 6.19717C16.0422 3.94103 17.8712 2.11206 20.1273 2.11206C22.3834 2.11206 24.2124 3.94103 24.2124 6.19717ZM22.7797 11.6753C24.8115 10.6897 26.2124 8.60703 26.2124 6.19717C26.2124 2.83646 23.488 0.112061 20.1273 0.112061C16.7666 0.112061 14.0422 2.83646 14.0422 6.19717C14.0422 8.60703 15.443 10.6897 17.4749 11.6753C13.4451 12.6963 10.3212 15.9898 9.54676 20.1121C9.42501 20.7601 9.36134 21.4287 9.36134 22.1121H11.3613H28.8933H30.8933C30.8933 21.4287 30.8296 20.7601 30.7078 20.1121C29.9334 15.9898 26.8095 12.6963 22.7797 11.6753ZM11.5905 20.1121C12.4954 16.2345 15.974 13.3461 20.1273 13.3461C24.2805 13.3461 27.7592 16.2345 28.6641 20.1121H11.5905Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.74512,
    y: 6.66522,
    width: 1.87234,
    height: 9.3617,
    rx: 0.93617,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 12.2823,
    width: 1.87234,
    height: 9.3617,
    rx: 0.93617,
    transform: "rotate(-90 0 12.2823)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddUser);
export default __webpack_public_path__ + "static/media/icon-add-user.bcc889d9f582dec5ed1dc85970029e87.svg";
export { ForwardRef as ReactComponent };